import { Data_getInstance2dtoxv2swnlhb as Data_getInstance } from './adapter/GrantDiscordAccessMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { GrantDiscordAccessMutationSelections_getInstance2n43lcc9w44io as GrantDiscordAccessMutationSelections_getInstance } from './selections/GrantDiscordAccessMutationSelections.mjs';
import { GrantDiscordAccessMutation_VariablesAdapter_instance3r6nddgmqgo6x as GrantDiscordAccessMutation_VariablesAdapter_instance } from './adapter/GrantDiscordAccessMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(grantDiscordAccess) {
        this.t6f_1 = grantDiscordAccess;
      }
      toString() {
        return 'Data(grantDiscordAccess=' + this.t6f_1 + ')';
      }
      hashCode() {
        return this.t6f_1 == null ? 0 : getBooleanHashCode(this.t6f_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.t6f_1 == other.t6f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.u6f_1 = obj(Data_getInstance());
        this.v6f_1 = (new (Builder())('data', Companion_getInstance().x6d_1)).t43(GrantDiscordAccessMutationSelections_getInstance().y6f_1).j37();
        this.w6f_1 = 'a0a2ff4fbaeeebae9d26579701f15dc651303e3d602f36a89a72adc301d4b383';
        this.x6f_1 = 'grantDiscordAccess';
      }
      a6e() {
        return 'mutation grantDiscordAccess($input: GrantDiscordAccessInput!) { grantDiscordAccess(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var GrantDiscordAccessMutationClass;
function GrantDiscordAccessMutation() {
  if (GrantDiscordAccessMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.z6f_1 = input;
      }
      c6e() {
        return 'a0a2ff4fbaeeebae9d26579701f15dc651303e3d602f36a89a72adc301d4b383';
      }
      operationId() {
        return this.c6e();
      }
      m47() {
        return Companion_getInstance_0().a6e();
      }
      d6e() {
        return 'grantDiscordAccess';
      }
      operationName() {
        return this.d6e();
      }
      q46(writer, customScalarAdapters, withDefaultValues) {
        GrantDiscordAccessMutation_VariablesAdapter_instance.a6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      p46() {
        return Companion_getInstance_0().u6f_1;
      }
      toString() {
        return 'GrantDiscordAccessMutation(input=' + this.z6f_1.toString() + ')';
      }
      hashCode() {
        return this.z6f_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessMutation()))
          return false;
        if (!this.z6f_1.equals(other.z6f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessMutation', VOID, VOID, [Mutation()]);
    GrantDiscordAccessMutationClass = $;
  }
  return GrantDiscordAccessMutationClass;
}
//region block: exports
export {
  Data as Data3pzhqfxhg1ap1,
  GrantDiscordAccessMutation as GrantDiscordAccessMutation1e5ff0b653k4l,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessMutation.mjs.map
